export enum TipoInsumos {
  SUB_DIARIO = 'SUB_DIARIO',
  DRIVER_VENTA = 'DRIVER_VENTA',
  TIPO_CAMBIO = 'TIPO_CAMBIO',
  INSUMO_1 = 'INSUMO_1',
  INSUMO_2 = 'INSUMO_2',
  REGISTRO_ACTIVIDADES = 'REGISTRO_ACTIVIDADES',
  COSTO_HORA = 'COSTO_HORA',
}
